import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';

import { ExportPowerBIReportFileFormat } from '@power-bi/models/export-power-bi-report-file-format';
import { EXPORT_POWER_BI_REPORT_FILE_DOWNLOAD_FORMAT_OPTIONS } from '@power-bi/models/export-power-bi-report-file-format-view';

@Component({
  selector: 'app-export-power-bi-report-dialog',
  templateUrl: './export-power-bi-report-dialog.component.html',
  styleUrls: ['./export-power-bi-report-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatRadioModule
  ]
})
export class ExportPowerBiReportDialogComponent {
  readonly #dialogRef = inject(
    MatDialogRef<ExportPowerBiReportDialogComponent>
  );

  readonly exportForm = new FormGroup({
    format: new FormControl<ExportPowerBIReportFileFormat>(
      ExportPowerBIReportFileFormat.PDF,
      { nonNullable: true }
    )
  });

  readonly ExportPowerBIReportFileFormatOptions =
    EXPORT_POWER_BI_REPORT_FILE_DOWNLOAD_FORMAT_OPTIONS;

  onGenerate(): void {
    if (!this.exportForm.valid) {
      return;
    }

    this.#dialogRef.close(this.format);
  }

  onClose(): void {
    this.#dialogRef.close();
  }

  //#region Private methods

  private get format(): ExportPowerBIReportFileFormat {
    return this.exportForm.controls.format.value;
  }

  //#endregion
}
